import React from 'react';
import Link from '@atlaskit/link';
import * as Styled from '../styled';
import { FormattedMessage } from 'react-intl-next';
import { getExperimentValue, getTargetingGate } from '../../../common/feature-gates';

const TermsAndPrivacyPolicy = () => {
	const shouldDisplayTryNow =
		getTargetingGate('project-pages-cta-content-update-gate') &&
		getExperimentValue('project-pages-cta-content-update', 'not-enrolled', true) === 'variation';

	return (
		<Styled.TermsAndPrivacyWrapper>
			{shouldDisplayTryNow ? <TermsAndPrivacyPolicyTryNow /> : <TermsAndPrivacyPolicyDefault />}
		</Styled.TermsAndPrivacyWrapper>
	);
};

const terms = (chunks: React.ReactNode[]) => (
	<Link target="_blank" href="https://www.atlassian.com/legal/cloud-terms-of-service">
		{chunks}
	</Link>
);

const privacyPolicy = (chunks: React.ReactNode[]) => (
	<Link target="_blank" href="https://www.atlassian.com/legal/privacy-policy">
		{chunks}
	</Link>
);

const TermsAndPrivacyPolicyDefault = () => (
	<FormattedMessage
		defaultMessage='By clicking "Try it free", you will be enrolled in Confluence and agree to the Atlassian <termsOfServiceLinkText>Cloud Terms of Service</termsOfServiceLinkText> and <privacyPolicyLinkText>Privacy Policy</privacyPolicyLinkText>.'
		id="projectpages.templatepreview.termsandprivacy"
		values={{
			termsOfServiceLinkText: terms,
			privacyPolicyLinkText: privacyPolicy,
		}}
	/>
);

const TermsAndPrivacyPolicyTryNow = () => (
	<FormattedMessage
		defaultMessage='By clicking "Try it now", you will be enrolled in Confluence and agree to the Atlassian <termsLink>Cloud Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>.'
		id="project-pages.improvement.terms-and-conditions-v2"
		values={{
			termsLink: terms,
			privacyLink: privacyPolicy,
		}}
	/>
);

export default TermsAndPrivacyPolicy;
